(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-faq-accordion')) {
  class TDFaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.items = null;
      this.handlers = [];
    }

    connectedCallback() {
      this.items = this.querySelectorAll('.td-faq__item');
      this.bindEvents();
    }

    disconnectedCallback() {
      this.removeEvents();
    }

    bindEvents() {
      this.items.forEach((item) => {
        const question = item.querySelector('.td-faq__question');
        if (question) {
          // Create and store bound handler for removal
          const handler = () => this.toggleItem(item);
          this.handlers.push({ element: question, handler });
          question.addEventListener('click', handler);
        }
      });
    }

    removeEvents() {
      this.handlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.handlers = [];
    }

    toggleItem(item) {
      const answerWrapper = item.querySelector('.td-faq__answer-wrapper');
      const question = item.querySelector('.td-faq__question');
      
      if (!answerWrapper || !question) return;

      const isActive = item.classList.contains('is-active');
      
      if (isActive) {
        // Close item
        item.classList.remove('is-active');
        question.setAttribute('aria-expanded', 'false');
        answerWrapper.setAttribute('aria-hidden', 'true');
        answerWrapper.style.maxHeight = '0px';
      } else {
        // Open item
        item.classList.add('is-active');
        question.setAttribute('aria-expanded', 'true');
        answerWrapper.setAttribute('aria-hidden', 'false');
        answerWrapper.style.maxHeight = answerWrapper.scrollHeight + 'px';
      }
    }
  }

  customElements.define('td-faq-accordion', TDFaqAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-header"] && !Shopify.designMode) return;
  try {
    
  /**
   * Intercepts clicks on links with [data-td-iframe-link] and opens them
   * in the td-iframe-modal instead of navigating away.
   */
  document.querySelectorAll('[data-td-iframe-link]').forEach(function(link) {
    link.addEventListener('click', function(evt) {
      evt.preventDefault();
      var url = link.getAttribute('href');
      var title = link.getAttribute('data-iframe-title') || '';
      if (url) {
        document.dispatchEvent(new CustomEvent('td-iframe-modal:open', {
          detail: { url: url, title: title }
        }));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-kit-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-kit-upsell')) {
    class TDKitUpsell extends HTMLElement {
      constructor() {
        super();

        // Get container with data attributes
        this.container = this.querySelector('.td-kit-upsell__container');
        if (!this.container) return;

        // DOM elements
        this.imageEl = this.querySelector('.td-kit-upsell__image');
        this.descriptionEl = this.querySelector('[data-description]');
        this.priceEl = this.querySelector('.td-kit-upsell__price');
        this.ctaButton = this.querySelector('[data-add-to-cart]');
        this.ctaPriceEl = this.querySelector('[data-cta-price]');
        this.ctaTextBold = this.querySelector('[data-cta-title]');
        this.seeInsideButton = this.querySelector('[data-see-inside]');

        this.firstProduct = {
          image: this.container.getAttribute('data-first-image') || '',
          imageSrcset: this.container.getAttribute('data-first-image-srcset') || '',
          productId: this.container.getAttribute('data-first-product') || '',
          variantId: this.container.getAttribute('data-first-variant') || '',
          price: this.container.getAttribute('data-first-price') || '',
          description: this.container.getAttribute('data-first-description') || '',
          title: this.container.getAttribute('data-first-title') || '',
        };

        this.secondProduct = {
          image: this.container.getAttribute('data-second-image') || '',
          imageSrcset: this.container.getAttribute('data-second-image-srcset') || '',
          productId: this.container.getAttribute('data-second-product') || '',
          variantId: this.container.getAttribute('data-second-variant') || '',
          price: this.container.getAttribute('data-second-price') || '',
          description: this.container.getAttribute('data-second-description') || '',
          title: this.container.getAttribute('data-second-title') || '',
        };

        this.kitButtons = this.querySelectorAll('.td-kit-upsell__kit-button');
        this.currentProductId = this.firstProduct.productId;
        this.currentVariantId = this.firstProduct.variantId;

        // Cart references
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // Event listeners
        this.kitButtons.forEach((button) => {
          button.addEventListener('click', this.handleKitButtonClick.bind(this));
        });

        if (this.seeInsideButton) {
          this.seeInsideButton.addEventListener('click', this.handleSeeInside.bind(this));
        }

        if (this.ctaButton) {
          this.syncCtaDataAttributes();
          this.ctaButton.addEventListener('click', this.handleAddToCart.bind(this));
        }
      }

      syncCtaDataAttributes() {
        if (!this.ctaButton) return;

        if (this.currentProductId) {
          this.ctaButton.setAttribute('data-product-id', this.currentProductId);
        } else {
          this.ctaButton.removeAttribute('data-product-id');
        }

        if (this.currentVariantId) {
          this.ctaButton.setAttribute('data-variant-id', this.currentVariantId);
        } else {
          this.ctaButton.removeAttribute('data-variant-id');
        }
      }

       handleSeeInside(event) {
         event.preventDefault();

         document.dispatchEvent(new CustomEvent('open-product-drawer', {
          detail: {
            productId: this.currentProductId,
          },
         }));
       }

      handleKitButtonClick(event) {
        const clickedButton = event.currentTarget;
        const clickedProductId = clickedButton.dataset.productId || clickedButton.getAttribute('data-kit');
        if (!clickedProductId) return;

        // Update active button
        this.kitButtons.forEach((button) => {
          button.classList.remove('td-kit-upsell__kit-button--active');
        });
        clickedButton.classList.add('td-kit-upsell__kit-button--active');

        const isFirstProduct = clickedProductId === this.firstProduct.productId;
        const productData = isFirstProduct ? this.firstProduct : this.secondProduct;
        const selectedTitle = clickedButton.dataset.kitTitle || productData.title;
        const selectedPrice = clickedButton.dataset.kitPrice || productData.price;
        this.currentProductId = clickedProductId;
        this.currentVariantId = clickedButton.dataset.variantId || productData.variantId;
        this.syncCtaDataAttributes();

        // Re-query in case another script has replaced the CTA markup.
        this.ctaPriceEl = this.querySelector('[data-cta-price]');
        this.ctaTextBold = this.querySelector('[data-cta-title]');

        if (this.imageEl && productData.image) {
          this.imageEl.src = productData.image;
          if (productData.imageSrcset) {
            this.imageEl.srcset = productData.imageSrcset;
          }
        }
        if (this.descriptionEl && productData.description) {
          this.descriptionEl.innerHTML = productData.description;
        }
        if (this.priceEl && selectedPrice) {
          this.priceEl.textContent = selectedPrice;
        }
        if (this.ctaPriceEl && selectedPrice) {
          this.ctaPriceEl.textContent = selectedPrice;
          this.ctaPriceEl.innerText = selectedPrice;
        }
        if (this.ctaTextBold && selectedTitle) {
          this.ctaTextBold.textContent = selectedTitle;
          this.ctaTextBold.innerText = selectedTitle;
        }

        // Keep the validator's saved HTML aligned with the currently selected kit.
        if (this.ctaButton) {
          this.ctaButton.dataset.originalKitHtml = this.ctaButton.innerHTML;
        }
      }

      handleAddToCart(event) {
        if (!this.currentVariantId) return;
        if (this.ctaButton.getAttribute('aria-disabled') === 'true') return;

        // Disable button and show loading state
        this.ctaButton.setAttribute('aria-disabled', 'true');
        this.ctaButton.classList.add('loading');
        const originalHTML = this.ctaButton.innerHTML;

        // Prepare form data
        const formData = new FormData();
        formData.append('id', this.currentVariantId);
        formData.append('quantity', 1);

        // Get cart drawer/notification if available
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && cart.getSectionsToRender) {
          // Match product-form.js pattern - append sections array directly
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }
        }

        // Fetch config - match product-form.js pattern
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        // Add to cart
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error adding to cart
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'td-kit-upsell',
                  productVariantId: this.currentVariantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              console.error('Error adding to cart:', response.description);
              this.ctaButton.innerHTML = originalHTML;
              this.ctaButton.removeAttribute('aria-disabled');
              this.ctaButton.classList.remove('loading');
              this.error = true;
              return;
            }

            // Success
            this.error = false;

            // If no cart drawer/notification, redirect to cart page
            if (!cart) {
              window.location = routes.cart_url;
              return;
            }

            // Update cart drawer/notification
            if (cart.renderContents) {
              cart.renderContents(response);
            }

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'td-kit-upsell',
                productVariantId: this.currentVariantId,
                cartData: response,
              });
            }
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            this.ctaButton.innerHTML = originalHTML;
            this.ctaButton.removeAttribute('aria-disabled');
            this.ctaButton.classList.remove('loading');
            this.error = true;
          })
          .finally(() => {
            this.ctaButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.ctaButton.removeAttribute('aria-disabled');
            }
          });
      }
    }

    customElements.define('td-kit-upsell', TDKitUpsell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-marquee')) {
  class TDMarquee extends HTMLElement {
    constructor() {
      super();
      this.debouncedResize = null;
    }

    connectedCallback() {
      this.initialize();
      this.duplicateTrackIfNeeded();
      
      // Store debounced handler reference for proper removal
      this.debouncedResize = this.debounce(() => this.handleResize(), 100);
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
        this.debouncedResize = null;
      }
    }

    initialize() {
      // Count all track elements that may have been pre-rendered by Liquid
      const TRACK_ELEMENTS = this.querySelectorAll('.td-track');
      this.trackCount = TRACK_ELEMENTS.length || 1; // Default to 1 if none found

      // The number 10 is arbitrary
      // This component can stutter during the animation reset
      // A large size reduces stutters and delays the first until a low importance time
      this.SIZE_MULTIPLIER = 10;

      // Use the first track as the reference for cloning
      this.TRACK = TRACK_ELEMENTS[0];

      // Calculate the total width of all existing tracks
      this.trackWidth = 0;
      if (this.TRACK) {
        const SINGLE_TRACK_WIDTH = this.TRACK.offsetWidth;
        // Sum up the width of all existing tracks
        this.trackWidth = SINGLE_TRACK_WIDTH * this.trackCount;
      }
    }

    duplicateTrackIfNeeded() {
      // This check prevents infinite duplication
      if (!this.TRACK || this.trackWidth === 0) {
        console.warn('TDMarquee: Track width is zero or track element not found. Cannot duplicate track.');
        return;
      }

      const originalTrackWidth = this.TRACK.offsetWidth;

      while (this.trackWidth < window.innerWidth * this.SIZE_MULTIPLIER) {
        const newTrack = this.TRACK.cloneNode(true);
        newTrack.setAttribute('aria-hidden', 'true');
        this.TRACK.parentNode.appendChild(newTrack);
        this.trackWidth += originalTrackWidth;
        this.trackCount++;
      }

      this.style.setProperty('--track-count', this.trackCount);
    }

    handleResize() {
      this.duplicateTrackIfNeeded();
    }

    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }
  }

  customElements.define('td-marquee', TDMarquee);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-showcase')) {
    class TDShowcase extends HTMLElement {
      constructor() {
        super();
        this.activeKitIndex = 0;
        
        // Elements
        this.toggleButtons = this.querySelectorAll('.td-showcase__toggle-btn');
        this.ratingContainers = this.querySelectorAll('.td-showcase__rating');
        this.kitContents = this.querySelectorAll('.td-showcase__kit-content');
        this.priceContents = this.querySelectorAll('.td-showcase__price-content');
        this.descContents = this.querySelectorAll('.td-showcase__desc-content');
        this.featuresLists = this.querySelectorAll('.td-showcase__features-list');
        this.sliderContainers = this.querySelectorAll('.td-showcase__slider-container');
        this.ctaButtons = this.querySelectorAll('.td-showcase__cta-btn');
        this.addonsSliderContainers = this.querySelectorAll('.td-showcase__addons-slider-container');
        
        this.expandButtons = this.querySelectorAll('[data-action="toggle-included"]');
        this.addonButtons = this.querySelectorAll('[data-add-to-cart]');

        this.init();
      }

      init() {
        // Toggle Listeners
        this.toggleButtons.forEach(btn => {
          btn.addEventListener('click', () => {
             const index = parseInt(btn.dataset.kitTarget);
             this.switchKit(index);
          });
        });

        // Expand Listeners
        this.expandButtons.forEach(btn => {
           btn.addEventListener('click', (e) => {
              const container = e.currentTarget.closest('.td-showcase__desc-content');
              container.classList.toggle('is-expanded');
           });
        });

        // Add to Cart Listeners
        this.addonButtons.forEach(btn => {
            btn.addEventListener('click', (e) => this.handleAddToCart(e));
        });
      }

      switchKit(index) {
         if (index === this.activeKitIndex) return;
         this.activeKitIndex = index;

         // Helper to toggle active class
         const toggleActive = (nodelist, updateAriaPressed = false) => {
          nodelist.forEach((el, i) => {
            if(i === index) {
              el.classList.add('is-active');
              if (updateAriaPressed) el.setAttribute('aria-pressed', 'true');
            } else {
              el.classList.remove('is-active');
              if (updateAriaPressed) el.setAttribute('aria-pressed', 'false');
            }
          });
         };

         toggleActive(this.toggleButtons, true);
         toggleActive(this.ratingContainers);
         toggleActive(this.kitContents);
         toggleActive(this.priceContents);
         toggleActive(this.descContents);
         toggleActive(this.featuresLists);
         toggleActive(this.sliderContainers);
         toggleActive(this.ctaButtons);
         toggleActive(this.addonsSliderContainers);
      }

      handleAddToCart(event) {
        const btn = event.currentTarget;
        const variantId = btn.dataset.variantId;
        
        if (!variantId) return;
        if (btn.getAttribute('aria-disabled') === 'true') return;

        // Disable button and show loading state
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        const originalHTML = btn.innerHTML;
        let error = false;

        // Prepare form data
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        // Get cart drawer/notification if available
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && cart.getSectionsToRender) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }
        }

        // Fetch config - match product-form.js pattern
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        const cartUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
        
        fetch(cartUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error adding to cart
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'td-showcase',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              console.error('Error adding to cart:', response.description);
              btn.innerHTML = originalHTML;
              btn.removeAttribute('aria-disabled');
              btn.classList.remove('loading');
              error = true;
              return;
            }

            // Success
            error = false;

            // If no cart drawer/notification, redirect to cart page
            if (!cart) {
              window.location = window.Shopify?.routes?.cart_url ? window.Shopify.routes.cart_url : '/cart';
              return;
            }

            // Update cart drawer/notification
            if (cart.renderContents) {
              cart.renderContents(response);
            }

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'td-showcase',
                productVariantId: variantId,
                cartData: response,
              });
            }
          })
          .catch((e) => {
            console.error('Error adding to cart:', e);
            btn.innerHTML = originalHTML;
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            error = true;
          })
          .finally(() => {
            btn.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            if (!error) {
              btn.removeAttribute('aria-disabled');
            }
          });
      }
    }
    
    customElements.define('td-showcase', TDShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-sickness-treatment"] && !Shopify.designMode) return;
  try {
    
/**
 * Treatment Item Web Component
 * Wraps each treatment item and emits custom event with treatment data
 */

if (!customElements.get('td-treatment-item')) {
  class TreatmentItem extends HTMLElement {
    constructor() {
      super();
      this.boundHandleActivation = null;
      this.boundHandleKeydown = null;
    }

    connectedCallback() {
      if (this.dataset.treatmentIgnore) {
        return;
      }
      
      this.sectionId = this.dataset.sectionId || '';
      this.treatmentData = {
        title: this.dataset.treatmentTitle || '',
        description: this.dataset.treatmentDescription || '',
        approvedKits: this.dataset.treatmentApprovedKits || [],
        failingKits: this.dataset.treatmentFailingKits || [],
        heading: this.dataset.treatmentHeading || '',
        medications: this.dataset.treatmentMedications || [],
        symptoms: this.dataset.treatmentSymptoms || [],
        calloutHeading: this.dataset.treatmentCalloutHeading || '',
        calloutContent: this.dataset.treatmentCalloutContent || '',
      };
      
      this.boundHandleActivation = this.handleActivation.bind(this);
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      
      this.addEventListener('click', this.boundHandleActivation);
      this.addEventListener('keydown', this.boundHandleKeydown);
    }

    disconnectedCallback() {
      if (this.boundHandleActivation) {
        this.removeEventListener('click', this.boundHandleActivation);
      }
      if (this.boundHandleKeydown) {
        this.removeEventListener('keydown', this.boundHandleKeydown);
      }
    }

    handleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleActivation();
      }
    }

    handleActivation() {
      const event = new CustomEvent('treatment-item-click', {
        detail: {
          sectionId: this.sectionId,
          treatmentData: this.treatmentData,
        },
        bubbles: true,
      });
      
      this.dispatchEvent(event);
    }
  }
  
  customElements.define('td-treatment-item', TreatmentItem);
}

/**
 * Show More functionality for treatment grid
 */
if (!customElements.get('td-show-more-button')) {
  class TdShowMoreButton extends HTMLElement {
    constructor() {
      super();
      this.boundHandleClick = null;
      this.isExpanded = false;
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.showMoreText = this.querySelector('.td-sickness-treatment__show-more-text');
      this.maxCountItemsMobile = this.button?.getAttribute('data-max-count-items-mobile') || 5;
      this.section = this.closest('.shopify-section');
      this.originalButtonTop = this.getBoundingClientRect().top + window.scrollY;
      
      if (this.section && this.button) {
        this.grid = this.section.querySelector('.td-sickness-treatment__grid');
        this.treatmentItems = this.section.querySelectorAll('td-treatment-item');
        
        if (this.treatmentItems.length <= this.maxCountItemsMobile) {
          this.style.display = 'none';
        }
        
        this.boundHandleClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.boundHandleClick);
      }
    }

    disconnectedCallback() {
      if (this.button && this.boundHandleClick) {
        this.button.removeEventListener('click', this.boundHandleClick);
      }
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      if (!this.grid || !this.treatmentItems) return;
      
      this.isExpanded = !this.isExpanded;
      const itemsToToggle = Array.from(this.treatmentItems).filter((item, index) => index >= this.maxCountItemsMobile);
      
      itemsToToggle.forEach(item => {
        if (this.isExpanded) {
          item.classList.remove('td-sickness-treatment__item--hidden-mobile');
        } else {
          item.classList.add('td-sickness-treatment__item--hidden-mobile');
        }
      });
      
      if (this.showMoreText) {
        this.showMoreText.textContent = this.isExpanded ? 'SHOW LESS' : 'SHOW MORE';
      }
      
      if (this.isExpanded && this.originalButtonTop !== undefined) {
        window.scrollTo({ top: this.originalButtonTop, behavior: 'smooth' });
      } else if (!this.isExpanded && this.section) {
        this.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
  customElements.define('td-show-more-button', TdShowMoreButton);
}

  } catch(e) { console.error(e); }
})();
})();
